"use strict";
(function () {
    const form = document.querySelector('form.VitaminDCalculator__Form');
    if (!form)
        return;
    initListeners();
    function initListeners() {
        form.addEventListener('submit', e => {
            e.preventDefault();
        });
        form.querySelectorAll('input').forEach(input => {
            input.addEventListener('input', displayResults);
        });
        form.querySelector('select[name="current_value_unit"]').addEventListener('change', () => {
            form.querySelector('input[name="current_value"]').dispatchEvent(new Event('input'));
        });
    }
    function formatNumber(value, maximumFractionDigits = 0) {
        return new Intl.NumberFormat('de-DE', {
            style: 'decimal',
            maximumFractionDigits
        }).format(value);
    }
    function checkTargetValueValidity(currentValue, targetValue) {
        const targetValueInput = form.querySelector('input[name="target_value"]');
        const targetValueLabel = targetValueInput.closest('label');
        if (!isNaN(targetValue) && !isNaN(currentValue) && targetValue < currentValue) {
            targetValueLabel.classList.add('error');
            targetValueLabel.querySelector('[data-form-input-error="impossible"]').classList.remove('none');
            targetValueLabel.querySelector('[data-form-input-error="illegal"]').classList.add('none');
            return false;
        }
        targetValueLabel.classList.remove('error');
        targetValueLabel.querySelector('[data-form-input-error="impossible"]').classList.add('none');
        targetValueLabel.querySelector('[data-form-input-error="illegal"]').classList.remove('none');
        return true;
    }
    function checkInputValidity(input) {
        const label = input.closest('label');
        if (input.checkValidity()) {
            label.classList.remove('error');
            return true;
        }
        else {
            label.classList.add('error');
            return false;
        }
    }
    function displayResults(e) {
        let currentValue = parseFloat(form.querySelector('input[name="current_value"]').value);
        const currentValueUnit = form.querySelector('select[name="current_value_unit"]').value;
        const targetValue = parseFloat(form.querySelector('input[name="target_value"]').value);
        const weight = parseFloat(form.querySelector('input[name="weight"]').value);
        const height = parseFloat(form.querySelector('input[name="height"]').value);
        const timeframe = parseInt(form.querySelector('input[name="timeframe"]').value);
        if (!Number.isNaN(currentValue) && currentValueUnit === 'nmol_l') {
            currentValue = currentValue / 2.5;
            form.querySelector('[data-form-value="converted_value"]').innerHTML = formatNumber(currentValue, 2);
            form.querySelector('[data-form-message="converted_value"]').classList.remove('none');
        }
        else {
            form.querySelector('[data-form-message="converted_value"]').classList.add('none');
        }
        const valid = checkTargetValueValidity(currentValue, targetValue) && checkInputValidity(e.target);
        form.setAttribute('data-form-valid', valid ? 'true' : 'false');
        if (form.getAttribute('data-form-valid') === 'false' || isNaN(currentValue) || isNaN(targetValue) || isNaN(weight) || isNaN(height) || isNaN(timeframe)) {
            form.querySelector('[data-form-message="result"]').classList.add('none');
            form.querySelector('[data-form-message="missing_data"]').classList.remove('none');
            return;
        }
        form.querySelector('[data-form-message="missing_data"]').classList.add('none');
        form.querySelector('[data-form-message="result"]').classList.remove('none');
        const results = calculateResults(currentValue, targetValue, weight, height, timeframe);
        form.querySelector('[data-form-value="total_need"]').innerHTML = formatNumber(results.totalCorrection);
        form.querySelector('[data-form-value="daily_need"]').innerHTML = formatNumber(results.dailyCorrection);
        form.querySelector('[data-form-value="maintenance_dose"]').innerHTML = formatNumber(results.maintenanceNeed);
    }
    function calculateResults(current, target, weight, height, days) {
        const totalCorrection = 143 * (target - current) * weight;
        const bmi = weight / Math.pow(height / 100, 2);
        const bmiFactor = bmi > 25 ? 1.5 : 1.0;
        const maintenanceNeed = 50 * weight * bmiFactor;
        const dailyCorrection = totalCorrection / days + maintenanceNeed;
        return { totalCorrection, dailyCorrection, maintenanceNeed };
    }
})();
